import VehicleFormLayout, { transformValues } from './form'
import GenericEditForm from '../common/edit'

export default () => <GenericEditForm formLayoutComponent={<VehicleFormLayout />} transformValues={transformValues} />
